// Author Liang Gangqiang
// Date 2023-06-27 10:06:12

import * as model from "@/model/sithMes/quality/SithMesQualityInspectTaskModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityInspectTask(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.operationSeq}
        },
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'incomingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'processFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'sithMesQualityInspectTaskEndFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'sithMesQualityInspectTaskIncomingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'sithMesQualityInspectTaskReturnStockFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'sithMesQualityInspectTaskOutsourceFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'incomingVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'processVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithMesQualityInspectTaskEndVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithMesQualityInspectTaskIncomingVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithMesQualityInspectTaskReturnStockVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithMesQualityInspectTaskOutsourceVo'
    })
    .buildStore()
